export const buildPaymentContextResultUrl = (
  path: string,
  paymentSource: string,
  txnId: string
): string => {
  const params = new URLSearchParams({
    paymentSource,
    txnId,
  });

  return `${path}?${params.toString()}`;
};

export const getPaymentSourceFromQuery = (queryString: string): string => {
  return new URLSearchParams(queryString).get('paymentSource') || 'PAY_VIA_LINK';
};
